import { useCallback, useContext } from 'react';
import STORE from '../../../../../store';
import AccountPickerContext from '../../../../../contexts/AccountPickerContext';
import { FindAndReplace } from '../types';
import useGetEnrichedReceipt from './useGetEnrichedReceipt';

const useGetFindAndReplaceReceipts = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const getEnrichedContent = useGetEnrichedReceipt();
  return useCallback(async (): Promise<
    FindAndReplace.EnrichedMetricReceipt[]
  > => {
    const getFindAndReplaceReceipts = async () => {
      const receiptsSnapshot = await STORE.getFindAndReplaceReceiptsRef({
        accountId: selectedAccountId,
      }).get();
      const receipts = receiptsSnapshot.docs.map((doc) => doc.data());

      return receipts
        .map((r) => {
          return {
            ...r,
            affectedContent: getEnrichedContent(r.affectedContentIds),
          };
        })
        .sort((a, b) => {
          if (a.createdOn > b.createdOn) {
            return -1;
          } else if (b.createdOn > a.createdOn) {
            return 1;
          }
          return 0;
        });
    };
    return Promise.resolve(getFindAndReplaceReceipts());
  }, [getEnrichedContent, selectedAccountId]);
};

export default useGetFindAndReplaceReceipts;
